import { Routes } from '@angular/router';
import { MarketplaceShellComponent } from './marketplace-shell.component';
import { MarketplaceHomeComponent } from './home/marketplace-home.component';
import { MarcaDetailComponent } from './marca/marca-detail.component';
import { SedeDetailComponent } from './sede/sede-detail.component';
import { MiCuentaComponent } from './cuenta/mi-cuenta.component';
import { RegistroClienteComponent } from './registro/registro-cliente.component';

// Marketplace del app de CLIENTES: buscar negocios y reservar. La gestión de negocio
// (dashboard, alta, agenda de la doctora, onboarding) vive en front-alphaC. Ver SPEC-021 (M4).
// Todas las rutas viven bajo el shell (que hostea el modal de auth). Las fijas van ANTES de :marca.
export const marketplaceRoutes: Routes = [
  {
    path: '',
    component: MarketplaceShellComponent,
    children: [
      { path: '', component: MarketplaceHomeComponent, title: 'Aura Marketplace' },
      { path: 'mi-cuenta', component: MiCuentaComponent, title: 'Mi cuenta' },
      // Wizard de alta de cliente (SPEC-030). Va ANTES de ':marca' o la ruta lo comeria
      // como si 'registro' fuese el slug de una marca.
      { path: 'registro', component: RegistroClienteComponent, title: 'Crear cuenta' },
      { path: ':marca', component: MarcaDetailComponent, title: 'Negocio' },
      { path: ':marca/:sede', component: SedeDetailComponent, title: 'Servicios' },
    ],
  },
];
